import { render, staticRenderFns } from "./FeedbackDetails.vue?vue&type=template&id=b7f2162a&scoped=true"
import script from "./FeedbackDetails.vue?vue&type=script&lang=js"
export * from "./FeedbackDetails.vue?vue&type=script&lang=js"
import style0 from "./FeedbackDetails.vue?vue&type=style&index=0&id=b7f2162a&prod&lang=scss&scoped=true"
import style1 from "./FeedbackDetails.vue?vue&type=style&index=1&id=b7f2162a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f2162a",
  null
  
)

export default component.exports